/** THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
export const SPACING = {
  'number-spacing-none': '0rem',
  'number-spacing-5xsmall': '0.125rem',
  'number-spacing-4xsmall': '0.25rem',
  'number-spacing-3xsmall': '0.375rem',
  'number-spacing-2xsmall': '0.5rem',
  'number-spacing-xsmall': '0.625rem',
  'number-spacing-small': '0.75rem',
  'number-spacing-medium': '1rem',
  'number-spacing-large': '1.25rem',
  'number-spacing-xlarge': '1.5rem',
  'number-spacing-2xlarge': '2rem',
  'number-spacing-3xlarge': '2.5rem',
  'number-spacing-4xlarge': '3rem',
  'number-spacing-5xlarge': '3.5rem',
  'number-spacing-6xlarge': '4rem',
  'number-spacing-7xlarge': '5rem',
  'number-spacing-8xlarge': '7.5rem'
}
